module.exports = __webpack_public_path__ + "media/webfonts/fa-solid-900-79da2134.ttf";